const options = [
    {
        brand: "Apple",
        devices: [
            {
                device: "iPhone"
            },
            {
                device: "iPad"
            },
        ]
    },
    {
        brand: "Samsung",
        devices: [
            {
                device: "Galaxy S"
            },
            {
                device: "Galaxy A"
            },
        ]
    },
    {
        brand: "Google",
        devices: [
            {
                device: "Pixel"
            }
        ]
    },
]

const types = [
    "Tempered Glass",
    "Privacy Glass",
    "Liquid Glass",
    "Red Light Glass",
    "Camera Lens",
    "BRIK Case"   
]

class FSCustomFilter extends HTMLElement {
    constructor() {
        super();
        this._onDocClick = this._onDocClick.bind(this);
        this.state = {
            brand: null,
            device: null,
            type: null,
            model: null
        };
        this.variants = this.dataset.variants.split("<-FS->");;
    }

    connectedCallback() {
        this._normalizeVariants();

        this._groupsMetadata = Array.from(this.querySelectorAll('fs-field-group')).map((group) => ({
            name: group.getAttribute('fs_name') || '',
            label: group.getAttribute('fs_label') || '',
        }));

        this._title = this.getAttribute('fs_title') || '';
        this._applyLabel = this.getAttribute('fs_apply-label') || 'Apply';

        // Do NOT initialize the state from the first option

        this.innerHTML = this._render();
        this._wire();

        document.addEventListener('click', this._onDocClick);

        this._updateAddToCartState();
    }

    disconnectedCallback() {
        document.removeEventListener('click', this._onDocClick);
    }

    _normalizeVariants() {
        this._normalizedVariants = this.variants.map((variant) => {
            let brand = '';
            if (variant.includes('iPhone') || variant.includes('iPad')) brand = 'Apple';
            else if (variant.includes('Samsung')) brand = 'Samsung';
            else if (variant.includes('Pixel')) brand = 'Google';

            let device = '';
            const brandConfig = options.find((b) => b.brand === brand);
            if (brandConfig) {
                const foundDevice = brandConfig.devices.find((d) =>
                    variant.toLowerCase().includes(d.device.toLowerCase())
                );
                if (foundDevice) device = foundDevice.device;
            }

            let type = 'Tempered Glass';
            if (variant.includes('PRIVACY')) type = 'Privacy Glass';
            else if (variant.includes('CAMERA LENS')) type = 'Camera Lens';
            else if (variant.includes('BRIK Case')) type = 'BRIK Case';
            else if (variant.includes('Liquid Glass')) type = 'Liquid Glass';
            else if (variant.includes('Red Light Glass')) type = 'Red Light Glass';

            return { variant, brand, device, type };
        });
    }

    _updatePipeline(changedField = 'brand') {
        if (changedField === 'brand') {
            const availableDevices = this._getAvailableDevices(this.state.brand);

            if (!availableDevices.find(d => d.value === this.state.device)) {
                this.state.device = null;
            }

            this.state.type = null;
            this.state.model = null;

            changedField = 'device';
        }

        if (changedField === 'device') {
            const availableTypes = this._getAvailableTypes(this.state.brand, this.state.device);

            if (!availableTypes.find(t => t.value === this.state.type)) {
                this.state.type = null;
            }

            this.state.model = null;

            changedField = 'type';
        }

        if (changedField === 'type') {
            const availableModels = this._getAvailableModels(
                this.state.brand,
                this.state.device,
                this.state.type
            );

            if (!availableModels.find(m => m.value === this.state.model)) {
                this.state.model = null;
            }
        }

        this._modelSelection();
        this._updateAddToCartState();
    }

    _getAvailableBrands() {
        return options.map(b => ({ value: b.brand, text: b.brand }));
    }

    _getAvailableDevices(brand) {
        const brandConfig = options.find(b => b.brand === brand);
        return brandConfig ? brandConfig.devices.map(d => ({ value: d.device, text: d.device })) : [];
    }

    _getAvailableTypes(brand, device) {
        const filtered = this._normalizedVariants.filter(v => v.brand === brand && v.device === device);
        const uniqueTypes = [...new Set(filtered.map(v => v.type))];
        return types.filter(t => uniqueTypes.includes(t)).map(t => ({ value: t, text: t }));
    }

    _getAvailableModels(brand, device, type) {
        return this._normalizedVariants
            .filter(v => v.brand === brand && v.device === device && v.type === type)
            .map(v => ({ value: v.variant, text: v.variant }));
    }

    _getOptionsForField(name) {
        switch (name) {
            case 'brand': return this._getAvailableBrands();
            case 'device': return this._getAvailableDevices(this.state.brand);
            case 'type': return this._getAvailableTypes(this.state.brand, this.state.device);
            case 'model': return this._getAvailableModels(this.state.brand, this.state.device, this.state.type);
            default: return [];
        }
    }

    _render() {
        const fieldsHtml = this._groupsMetadata
            .map((meta, i) => `<div class="fs_filter__field" data-fs-field="${this._escape(meta.name)}" data-fs-index="${i}">${this._renderField(meta.name)}</div>`)
            .join('');

        

        return `
        <div class="fs_filter">
          ${this._title ? `<h2 class="fs_filter__title">${this._escape(this._title)}</h2>` : ''}
          <div class="fs_filter__row">
            ${fieldsHtml}
            <button type="button" class="fs_filter__apply">${this._escape(this._applyLabel)}</button>
          </div>
        </div>`;
    }

    _renderField(name) {
        const meta = this._groupsMetadata.find(m => m.name === name);
        const groupOptions = this._getOptionsForField(name);
        const selectedValue = this.state[name];

        const selectedOption = groupOptions.find(o => o.value === selectedValue);

        const placeholder = `Select ${meta.label}`;

        const disabled =
            (name === "device" && !this.state.brand) ||
            (name === "type" && !this.state.device) ||
            (name === "model" && !this.state.type);

        const optionsHtml = groupOptions.map(
            (opt) => `
                <li class="fs_filter__option${opt.value === selectedValue ? ' fs_is-active' : ''}"
                    role="option"
                    data-fs-value="${this._escape(opt.value)}"
                    aria-selected="${opt.value === selectedValue}">
                    ${this._escape(opt.text)}
                </li>`
        ).join('');

        return `
            <span class="fs_filter__label">${this._escape(meta.label)}</span>

            <button
                type="button"
                class="fs_filter__select"
                aria-haspopup="listbox"
                aria-expanded="false"
                data-fs-value="${this._escape(selectedOption?.value || '')}"
                ${disabled ? 'disabled' : ''}
            >
                <span class="fs_filter__value">
                    ${this._escape(selectedOption ? selectedOption.text : placeholder)}
                </span>
                <span class="fs_filter__chevron" aria-hidden="true"></span>
            </button>

            <ul class="fs_filter__dropdown" role="listbox" hidden>
                ${optionsHtml}
            </ul>
        `;
    }

    _wire() {
        this._fields = Array.from(this.querySelectorAll('.fs_filter__field'));
        this._fields.forEach(field => this._wireField(field));

        const applyBtn = this.querySelector('.fs_filter__apply');
        applyBtn.addEventListener('click', () => {
            this.dispatchEvent(new CustomEvent('fs:apply', { detail: this.state, bubbles: true }));
        });
    }

    _wireField(field) {
        const trigger = field.querySelector('.fs_filter__select');
        const dropdown = field.querySelector('.fs_filter__dropdown');

        trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            const isOpen = field.classList.contains('fs_is-open');
            this._closeAll();
            if (!isOpen) this._openField(field);
        });

        dropdown.querySelectorAll('.fs_filter__option').forEach((opt) => {
            opt.addEventListener('click', (e) => {
                e.stopPropagation();
                this._selectOption(field, opt);
            });
        });
    }

    _selectOption(field, opt) {
        const name = field.getAttribute('data-fs-field');
        const value = opt.getAttribute('data-fs-value');
        const index = parseInt(field.getAttribute('data-fs-index'));

        this.state[name] = value;
        this._updatePipeline(name);

        // Update current and subsequent fields only
        for (let i = index; i < this._groupsMetadata.length; i++) {
            const meta = this._groupsMetadata[i];
            const fieldEl = this.querySelector(`.fs_filter__field[data-fs-field="${meta.name}"]`);
            if (fieldEl) {
                fieldEl.innerHTML = this._renderField(meta.name);
                this._wireField(fieldEl);
            }
        }

        this._closeAll();

        this.dispatchEvent(
            new CustomEvent('fs:change', {
                detail: { name, value, text: opt.textContent.trim(), state: this.state },
                bubbles: true,
            })
        );

        this._updateAddToCartState();
    }

    _openField(field) {
        field.classList.add('fs_is-open');
        field.querySelector('.fs_filter__select').setAttribute('aria-expanded', 'true');
        field.querySelector('.fs_filter__dropdown').hidden = false;
    }

    _closeAll() {
        this._fields.forEach((field) => {
            field.classList.remove('fs_is-open');
            field.querySelector('.fs_filter__select').setAttribute('aria-expanded', 'false');
            field.querySelector('.fs_filter__dropdown').hidden = true;
        });
    }

    _onDocClick(e) {
        if (!this.contains(e.target)) this._closeAll();
    }

    _escape(str) {
        const div = document.createElement('div');
        div.textContent = str == null ? '' : String(str);
        return div.innerHTML;
    }

    _modelSelection(){
        const oglabels = document.querySelector(`.xo-product-variant__inner .xo-field-select-custom__check[aria-label='${this.state.model}']`);
        if(oglabels){
            oglabels.click();
        }

        // Add line item properties
        const form = document.querySelector(".shopify-product-form");
        if (!form) return;

        const properties = {
            Brand: this.state.brand,
            Device: this.state.device,
            Type: this.state.type
        };

        Object.entries(properties).forEach(([key, value]) => {
            let input = form.querySelector(
                `input[name="properties[${key}]"]`
            );

            if (!input) {
                input = document.createElement("input");
                input.type = "hidden";
                input.name = `properties[${key}]`;
                form.appendChild(input);
            }

            input.value = value || "";
        });
    }

    _updateAddToCartState() {
        const enabled =
            !!this.state.brand &&
            !!this.state.device &&
            !!this.state.type &&
            !!this.state.model;

        this.setAttribute("options-selected", enabled);
    }
}

if(!customElements.get('fs-custom-filter')){
    customElements.define('fs-custom-filter', FSCustomFilter);
}


